import { Field, ErrorMessage, FieldInputProps } from "formik";
import { useTranslation } from "react-i18next";
import { TitleInput } from "@/screens/register/register-engineer/style";
import InputWithIcon from "@/components/input/input";
import MaskedInput from "@/components/input/inputMask";
import { ErrorText, MarginBottom } from "@/screens/login/login-seller/style";
import { FaWpforms } from "react-icons/fa";
import { MdCorporateFare } from "react-icons/md";
import { LocationSelector } from "@/components/location-selector/location-selector";

interface Props {
  registerError: any;
}

export default function StepEngineerAddress({ registerError }: Props) {
  const { t } = useTranslation();

  return (
    <>
      <MarginBottom />

      <LocationSelector />
    </>
  );
}
